import { RedirectionStateObject } from '../types';
import { tanstackUrlSearch } from '../utils';

export const ShortUrlRedirections: RedirectionStateObject = {
  'short-url-goto': ({ urlId, ...rest }) => `/360/short-url/${urlId}${tanstackUrlSearch(rest)}`,
  'explore-goto': ({ urlId, ...rest }) => `/360/short-url/${urlId}${tanstackUrlSearch(rest)}`,
  goto: ({ urlId, ...rest }) => `/360/short-url/${urlId}${tanstackUrlSearch(rest)}`,
};
